import { render, staticRenderFns } from "./CourseCatalogue.vue?vue&type=template&id=5104e828&"
import script from "./CourseCatalogue.vue?vue&type=script&lang=js&"
export * from "./CourseCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./CourseCatalogue.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports